<template>
  <div class="tr columns">
    <span class="delete-cell"><img src="/static/img/icons/delete.svg" class="delete-icon" @click="deleteConsultationRequest(request.id)"/></span>
    <span class="name column">{{ request.name }}</span>
    <span class="phone column">
      <strong>Телефон:</strong> <br>
      {{ request.phone }} <br>
      <div v-if="request.city">
        <strong>Город:</strong> <br>
        {{ request.city }} <br>
      </div>
    </span>
    <span class="column">{{ request.time }}</span>
    <span class="column">
      <b-switch v-model="request.isProcessed" @change="updateConsultationRequest(request)">Обработан</b-switch>
    </span>
    <span>{{ request.created_at | formatDate }}</span>
  </div>
</template>

<script>
import { mapActions } from 'vuex'

export default {
  name: 'ServiceRequestItem',
  data () {
    return {
      showUrl: false
    }
  },
  props: {
    request: {
      required: true
    }
  },
  methods: {
    ...mapActions(['updateConsultationRequest', 'deleteConsultationRequest'])
  },
  filters: {
    formatDate (date) {
      if (date) {
        const d = new Date(date)
        return `${d.getFullYear()}/${d.getMonth() + 1}/${d.getDate()}`
      }
    }
  }
}
</script>
<style scoped>
span {
  padding: 15px;
  display: inline-block;
  min-width: 19%;
}
.tr {
  background: #eee;
  margin: 10px 5px;
}
.name {
  font-weight: bold;
}
.link {
  padding: 0;
}
.delete-icon {
  position: initial;
  vertical-align: middle;
}
a:visited {
  color: #1464f6;
}
.delete-cell {
  min-width: 55px;
}
</style>



// WEBPACK FOOTER //
// ConsultationRequestItem.vue?ffcb7bb2